"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeviceLevel = getDeviceLevel;

var _runtime = _interopRequireDefault(require("./runtime"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDeviceLevel() {
  return _runtime.default.get('deviceLevel') || 'NOT_READY';
}